import { render, staticRenderFns } from "./BestaetigenSofort.vue?vue&type=template&id=0e18c4db"
import script from "./BestaetigenSofort.vue?vue&type=script&lang=ts"
export * from "./BestaetigenSofort.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports